module.exports = __webpack_public_path__ + "static/media/Abendessen.105f1c96.png";